<template>
  <app-layout>
    
    <h1><span class="handFont">SPORT</span><span class="gray">app</span></h1>
    <div class='clearfix'></div>
    <br>
    <p class="loud">Time to get in shape!</p>
    <hr>
    <div class="brow">
      <div class='col-sm-2' v-for="icn in icons" :key="'icon:' + icn">
        <div class='press seventy'>
          <i :class="'previewIcn icon-' + icn" />
          <div class='clearfix'></div>
          <p class='bold'>{{ icn }}</p>
          <br>
        </div>
        
      </div>
    </div>

    <v-bottom-nav :value="true" fixed>
      <v-btn to="/">
        <span>Home</span>
        <i class="icon-home"></i>
      </v-btn>
      <v-btn to="/workouts">
        <span>All Workouts</span>
        <i class="icon-accessibility"></i>
      </v-btn>
      <v-btn to="/settings">
        <span>Settings</span>
        <i class="icon-cogs"></i>
      </v-btn>
    </v-bottom-nav>

  </app-layout>
</template>

<script>
export default {
  data() {
    return {
      icons: [
        'home', 'newspaper', 'pencil', 'image', 'profile', 'envelop', 'pushpin', 'history', 'stopwatch', 'calendar', 'mobile', 
        'undo2', 'redo2', 'user', 'key', 'key2', 'lock', 'unlocked', 'cog', 'cogs', 'stats-dots', 'trophy', 'meter', 'fire', 
        'bin', 'accessibility', 'power', 'switch', 'clipboard', 'menu', 'cloud', 'cloud-download', 'cloud-upload', 'cloud-check', 
        'earth', 'eye', 'eye-blocked', 'star-empty', 'star-full', 'heart', 'smile', 'sad', 'shocked', 'neutral', 'warning', 
        'plus', 'minus', 'info', 'cross', 'checkmark', 'enter', 'exit', 'arrow-right', 'arrow-left', 'arrow-right2', 
        'arrow-left2', 'checkbox-checked', 'checkbox-unchecked', 'filter', 'mail2'
      ]
    }
  }
}
</script>

<style lang="scss">
.previewIcn {
  display: block;
  font-size: 50px;
  color: #999;
  margin-bottom: 10px;
}
</style>
